// extracted by mini-css-extract-plugin
export default {"root":"src-feature-ui-__link_root"};